var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3235",
    "data-name": "Grupo 3235",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\uCC3Dngulo_2991",
    "data-name": "Ret\\uCC3Dngulo 2991",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fae3bd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\uCC3Dngulo_2992",
    "data-name": "Ret\\uCC3Dngulo 2992",
    width: 48,
    height: 48,
    rx: 24,
    fill: "none",
    stroke: "#fdf8ed",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4299",
    "data-name": "Grupo 4299",
    transform: "translate(33.606 14.393) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3252",
    "data-name": "Caminho 3252",
    d: "M0,0H19.216V19.216H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3253",
    "data-name": "Caminho 3253",
    d: "M0,4.8V0",
    transform: "translate(5.605 12.01)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3254",
    "data-name": "Caminho 3254",
    d: "M4.8,2.4,2.4,0,0,2.4",
    transform: "translate(11.209 2.402)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3255",
    "data-name": "Caminho 3255",
    d: "M0,0V14.412",
    transform: "translate(13.611 2.402)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3256",
    "data-name": "Caminho 3256",
    d: "M4.8,0,2.4,2.4,0,0",
    transform: "translate(3.203 14.412)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3257",
    "data-name": "Caminho 3257",
    d: "M0,0V1.6",
    transform: "translate(5.605 2.402)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3258",
    "data-name": "Caminho 3258",
    d: "M0,0V1.6",
    transform: "translate(5.605 7.206)",
    fill: "none",
    stroke: "#fdac2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.2dd0d42184a57e05e56a269efa071159.svg";
export { ForwardRef as ReactComponent };